import '@strapi/icons';
export { i as DocumentRBAC, D as DocumentStatus, k as buildValidParams, W as default, X as unstable_useContentManagerContext, U as unstable_useDocument, Y as unstable_useDocumentActions, d as unstable_useDocumentLayout, o as useDocumentRBAC } from './chunks/index-DsOgMEE-.mjs';
import 'prismjs';
import 'react/jsx-runtime';
import '@strapi/admin/strapi-admin';
import 'react';
import '@strapi/design-system';
import 'lodash/fp/mapValues';
import 'react-intl';
import 'react-router-dom';
import 'styled-components';
import 'yup';
import 'fractional-indexing';
import 'lodash/fp/pipe';
import 'qs';
import 'date-fns';
import '@reduxjs/toolkit';
//# sourceMappingURL=index.mjs.map
